import { useFormik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { httpRequest } from "../utils/httpRequest";
import { CartContext } from "../context/CartContext";
import { useNavigate } from "react-router-dom";
import { paymentRequest } from "../utils/payment";
import * as Yup from "yup";
import { iranLocations } from "./iranLocations"; // مسیر فایل بالا را تنظیم کنید

const CheckoutForm = ({ packing, total }) => {
  const [cities, setCities] = useState([]);
  const [loading, setloading] = useState(false);
  const [checked, setchecked] = useState(false);

  const navigate = useNavigate();
  const { cart, setCart } = useContext(CartContext);

  // دریافت اطلاعات کاربر لاگین شده
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?._id) {
      httpRequest(
        "GET",
        `/user/info/${user._id}`,
        {},
        { "x-access-token": user?.token },
      ).then(({ data }) => {
        if (data?.data?.user) {
          const userData = data.data.user;
          Object.keys(userData).forEach((key) => {
            if (key in formik.initialValues) {
              formik.setFieldValue(key, userData[key]);
            }
          });
        }
      });
    }
  }, []);

  const VALUE_SIGN_VALIDATION = Yup.object({
    name: Yup.string().required("الزامی است"),
    phone: Yup.string().required("الزامی است"),
    address: Yup.string().required("الزامی است"),
    state: Yup.string().required("الزامی است"),
    city: Yup.string().required("الزامی است"),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      phone: "",
      address: "",
      state: "",
      city: "",
      postalCode: "",
    },
    validationSchema: VALUE_SIGN_VALIDATION,
    onSubmit: async (values) => {
      if (!checked) {
        return toast.error("با شرایط و مقررات سایت موافقت نشده");
      }
      setloading(true);
      const user = JSON.parse(localStorage.getItem("user"));

      // ساخت آرایه محصولات بدون دستکاری مستقیم state
      const products = cart.map((e) => ({
        productId: e.id,
        count: e.count,
        price: e?.special_price ? e?.special_price : e?.price,
      }));

      const payload = {
        ...values,
        allPrice: total,
        userId: user?._id,
        products,
      };

      try {
        const response = await httpRequest("POST", "/order", payload, {});
        if (response?.status === 201) {
          localStorage.setItem("amount", total);
          localStorage.setItem("orderId", response.data.data._id);
          setCart([]);
          await paymentRequest(total, response.data.data._id);
        } else {
          toast.error(response?.data?.message || "خطا در ثبت سفارش");
        }
      } catch (err) {
        toast.error("خطا در برقراری ارتباط با سرور");
      } finally {
        setloading(false);
      }
    },
  });

  // به‌روزرسانی شهرهای استان انتخاب‌شده
  useEffect(() => {
    const selectedState = formik.values.state;
    if (selectedState) {
      const targetState = iranLocations.find(
        (item) => item.name === selectedState,
      );
      setCities(targetState ? targetState.cities : []);
    } else {
      setCities([]);
    }
    // صفر کردن مقدار شهر در صورت تغییر استان
    formik.setFieldValue("city", "");
  }, [formik.values.state]);

  return (
    <form
      onSubmit={formik.handleSubmit}
      dir="rtl"
      className="mt-10 bg-gray-50 px-4 pt-8 lg:mt-0"
    >
      <p className="text-xl font-medium">اطلاعات خرید</p>
      <p className="text-gray-400">اطلاعات خود را برای سفارش کامل کنید</p>

      <div className="grid md:grid-cols-2 gap-2 mt-4">
        <span>
          <label htmlFor="name" className="mb-2 block text-sm font-medium">
            نام و نام خانوادگی*
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full rounded-md border border-gray-200 px-3 py-3 text-sm shadow-sm outline-none focus:border-blue-500"
          />
          {formik.errors.name && formik.touched.name && (
            <small className="text-red-500">{formik.errors.name}</small>
          )}
        </span>

        <span>
          <label htmlFor="phone" className="mb-2 block text-sm font-medium">
            شماره تماس*
          </label>
          <input
            type="text"
            id="phone"
            name="phone"
            value={formik.values.phone}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full rounded-md border border-gray-200 px-3 py-3 text-sm shadow-sm outline-none focus:border-blue-500"
          />
          {formik.errors.phone && formik.touched.phone && (
            <small className="text-red-500">{formik.errors.phone}</small>
          )}
        </span>

        <span>
          <label
            htmlFor="postalCode"
            className="mb-2 block text-sm font-medium"
          >
            کد پستی
          </label>
          <input
            type="text"
            id="postalCode"
            name="postalCode"
            value={formik.values.postalCode}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full rounded-md border border-gray-200 px-3 py-3 text-sm shadow-sm outline-none focus:border-blue-500"
          />
        </span>

        <span>
          <label htmlFor="state" className="mb-2 block text-sm font-medium">
            استان*
          </label>
          <select
            id="state"
            name="state"
            value={formik.values.state}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full rounded-md border border-gray-200 px-3 py-3 text-sm shadow-sm outline-none focus:border-blue-500"
          >
            <option value="">انتخاب استان...</option>
            {iranLocations.map((item) => (
              <option key={item.name} value={item.name}>
                {item.name}
              </option>
            ))}
          </select>
          {formik.errors.state && formik.touched.state && (
            <small className="text-red-500">{formik.errors.state}</small>
          )}
        </span>

        <span>
          <label htmlFor="city" className="mb-2 block text-sm font-medium">
            شهر*
          </label>
          <select
            id="city"
            name="city"
            value={formik.values.city}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={!formik.values.state}
            className="w-full rounded-md border border-gray-200 px-3 py-3 text-sm shadow-sm outline-none focus:border-blue-500 disabled:bg-gray-200"
          >
            <option value="">انتخاب شهر...</option>
            {cities.map((cityName) => (
              <option key={cityName} value={cityName}>
                {cityName}
              </option>
            ))}
          </select>
          {formik.errors.city && formik.touched.city && (
            <small className="text-red-500">{formik.errors.city}</small>
          )}
        </span>

        <span className="col-span-full">
          <label htmlFor="address" className="mb-2 block text-sm font-medium">
            آدرس*
          </label>
          <textarea
            id="address"
            name="address"
            value={formik.values.address}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full rounded-md border border-gray-200 px-3 py-3 text-sm shadow-sm outline-none focus:border-blue-500"
          />
          {formik.errors.address && formik.touched.address && (
            <small className="text-red-500">{formik.errors.address}</small>
          )}
        </span>

        <span className="col-span-full">
          <p className="text-sm text-gray-500 mt-2">
            از داده‌های شخصی شما برای پردازش سفارش و تجربه بهتر کاربری استفاده
            خواهد شد.
          </p>
          <label className="flex gap-2 mt-4 items-center cursor-pointer">
            <input
              type="checkbox"
              onChange={(e) => setchecked(e.target.checked)}
              checked={checked}
            />
            <span className="text-sm">
              من شرایط و مقررات سایت را خوانده‌ام و آن را می‌پذیرم
            </span>
          </label>
        </span>
      </div>

      {loading ? (
        <div role="status" className="flex justify-center my-6">
          <div className="w-8 h-8 border-4 border-gray-300 border-t-gray-900 rounded-full animate-spin" />
        </div>
      ) : (
        <button
          type="submit"
          className="mt-6 mb-8 w-full rounded-md bg-gray-900 px-6 py-3 font-medium text-white hover:bg-gray-800"
        >
          ارسال سفارش
        </button>
      )}
    </form>
  );
};

export default CheckoutForm;
